'use client';

import { motion } from 'motion/react';
import { CheckCircle2 } from 'lucide-react';

export default function Scalability() {
  return (
    <section className="bg-[#141414] py-24 px-6 md:px-12 lg:px-24 border-y border-zinc-800/50">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-24 items-center">
          
          {/* Left Grid */}
          <div className="flex flex-col gap-4">
            <div className="grid grid-cols-2 gap-4">
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="rounded-lg border border-zinc-800 bg-[#0a0a0a] p-8"
              >
                <div className="mb-2 text-4xl font-black text-[#b4ff00]">500+</div>
                <div className="text-[10px] font-bold tracking-widest text-zinc-500">FEDERATIONS JOINED</div>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 }}
                className="rounded-lg border border-zinc-800 bg-[#0a0a0a] p-8"
              >
                <div className="mb-2 text-4xl font-black text-white">∞</div>
                <div className="text-[10px] font-bold tracking-widest text-zinc-500">TEAM SCALING</div>
              </motion.div>
            </div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="rounded-lg border border-zinc-800 bg-[#0a0a0a] p-8"
            >
              <h3 className="mb-2 text-2xl font-black text-white">Multi-Tenant</h3>
              <p className="text-sm text-zinc-400">Architected for hyper-scale sports conglomerates.</p>
            </motion.div>
          </div>

          {/* Right Content */}
          <div>
            <motion.h2
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="mb-6 text-3xl font-black tracking-tight text-white md:text-4xl"
            >
              Unmatched Scalability
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="mb-10 text-zinc-400 leading-relaxed"
            >
              Our hierarchical engine isn't just about order—it's about growth. Launch new territories and competitions in minutes, not months. The system grows modularly with your expansion.
            </motion.p>
            
            <div className="space-y-4">
              {[
                "Shared Resource Management",
                "Global Visibility across Sub-Entities",
                "Decentralized Admin Delegations"
              ].map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}
                  className="flex items-center gap-3"
                >
                  <CheckCircle2 size={20} className="text-[#b4ff00]" />
                  <span className="text-sm font-bold text-white">{item}</span>
                </motion.div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
